import { render, staticRenderFns } from "./CategoriesSection.vue?vue&type=template&id=793e2bdc&scoped=true&"
import script from "./CategoriesSection.vue?vue&type=script&lang=js&"
export * from "./CategoriesSection.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesSection.vue?vue&type=style&index=0&id=793e2bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793e2bdc",
  null
  
)

/* custom blocks */
import block0 from "./CategoriesSection.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports